import { Link } from 'react-router-dom'

export default function Logo({ size = 'default', className = '', linkTo = null }) {
  const sizes = {
    small: 'h-12',
    default: 'h-20',
    large: 'h-28'
  }

  const sizeClass = sizes[size] || sizes.default

  const logoImage = (
    <img
      src="/RDC_Logomark_Orange.png"
      alt="Riding & Driving Club"
      className={`${sizeClass} w-auto ${className}`}
    />
  )

  // If linkTo is provided, wrap in a Link
  if (linkTo) {
    return (
      <Link to={linkTo} className="block hover:opacity-90 transition-opacity">
        {logoImage}
      </Link>
    )
  }

  return logoImage
}
